import React from "react"
import { Image, OverlayTrigger, Popover } from "react-bootstrap"

import AuthButton from "./AuthButton"
import InfoIcon from 'assets/images/info.svg';

import "./CustomButtonWithTips.scss"

const CustomButtonWithTips = ({
  tipsContent,
  tipsPosition = "bottom-end",
  hidden,
  children,
  title,
  ...others
}) => {
  return (
    <div className='custom-button-with-tips btn-download' hidden={hidden}>
      <AuthButton
        {...others}
      >
        <div className="d-flex flex-gap-4" style={{ alignItems: "center" }}>
          <div>{children || title}</div>
          {tipsContent &&
            <OverlayTrigger
              rootClose
              placement={tipsPosition}
              overlay={
                <Popover className='caution-container'>
                  <Popover.Content
                    className={`caution-content`}
                  >
                    {tipsContent || ''}
                  </Popover.Content>
                </Popover>}
            >
              <Image src={InfoIcon} />
            </OverlayTrigger>
          }
        </div>
      </AuthButton>
    </div>)
}

export default CustomButtonWithTips;